import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';

const STORAGE_LANG_KEY = 'login-lang';
const SUPPORTED_LANGS = ['en', 'ar', 'ru'] as const;
type SupportedLang = (typeof SUPPORTED_LANGS)[number];

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'unified-login-app';

  constructor(
    private router: Router,
    private transloco: TranslocoService
  ) {}

  ngOnInit(): void {
    this.applyAcceptLanguageFromQuery();
  }

  /**
   * When another app redirects here with Accept-Language (e.g. ?Accept-Language=ar),
   * ensure we use that language, persist it, and set document lang/dir.
   */
  private applyAcceptLanguageFromQuery(): void {
    const lang = this.getAcceptLanguageFromQuery();
    if (!lang) return;
    this.transloco.setActiveLang(lang);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_LANG_KEY, lang);
    }
    this.setDocumentLangAndDir(lang);
  }

  private getAcceptLanguageFromQuery(): SupportedLang | null {
    const q = this.router.routerState.snapshot.root.queryParams;
    const lang = (q['Accept-Language'] ?? q['accept-language']) as string | undefined;
    return lang && SUPPORTED_LANGS.includes(lang as SupportedLang) ? (lang as SupportedLang) : null;
  }

  private setDocumentLangAndDir(lang: SupportedLang): void {
    if (typeof document === 'undefined' || !document.documentElement) return;
    document.documentElement.lang = lang === 'ar' ? 'ar' : lang === 'ru' ? 'ru' : 'en';
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }
}
